import { render, staticRenderFns } from "./DepartmentsTab.vue?vue&type=template&id=352af306&scoped=true"
import script from "./DepartmentsTab.vue?vue&type=script&lang=js"
export * from "./DepartmentsTab.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsTab.vue?vue&type=style&index=0&id=352af306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352af306",
  null
  
)

export default component.exports